import type { Route } from '@angular/router';
import { EnergyOrderGasPermissions } from '@backoffice/shared/bo/util-permissions';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { faBurn } from '@fortawesome/pro-solid-svg-icons';
import { ngxPermissionsGuard } from 'ngx-permissions';

const gasListWithPreviewChildren: Route[] = [
  {
    path: 'preview/:id',
    loadComponent: () =>
      import('./form/gas-form.component').then((mod) => mod.GasFormComponent),
    canDeactivate: [CanDeactivateGuard],
  },
];

export const contractGasTab: Route = {
  path: 'contract',
  loadComponent: () =>
    import('./contract-tabs-gas/contract-tabs-gas.component').then(
      (mod) => mod.ContractTabsGasComponent,
    ),
  children: [
    { path: '', redirectTo: 'contracts', pathMatch: 'full' as const },
    {
      path: 'unaccepted-contracts',
      loadComponent: () =>
        import('./gas-list.component').then((mod) => mod.GasListComponent),
      data: { isUnaccepted: true, hideTitle: true },
      children: gasListWithPreviewChildren,
    },
    {
      path: 'contracts',
      loadComponent: () =>
        import('./gas-list.component').then((mod) => mod.GasListComponent),
      data: { isUnaccepted: false, hideTitle: true },
      children: gasListWithPreviewChildren,
    },
  ],
  canActivate: [ngxPermissionsGuard],
  data: {
    label: 'customer-pools.fields.CONTRACT',
    permissions: {
      only: EnergyOrderGasPermissions.tabPermisssion,
    },
  },
};

export const contractGasRoute: Route = {
  path: 'gas',
  loadComponent: () =>
    import('./contract-tabs-gas/contract-tabs-gas.component').then(
      (mod) => mod.ContractTabsGasComponent,
    ),
  children: [
    { path: '', redirectTo: 'contracts', pathMatch: 'full' },
    {
      path: 'unaccepted-contracts',
      loadComponent: () =>
        import('./gas-list.component').then((mod) => mod.GasListComponent),
      data: { isUnaccepted: true, hideTitle: true },
      children: gasListWithPreviewChildren,
    },
    {
      path: 'contracts',
      loadComponent: () =>
        import('./gas-list.component').then((mod) => mod.GasListComponent),
      data: { isUnaccepted: false, hideTitle: true },
      children: gasListWithPreviewChildren,
    },
  ],
  data: {
    translate: 'contracts.gas',
    titleIcon: {
      icon: faBurn,
      class: 'gas-icon',
    },
  },
};
